import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useEnterpriseLearningPathPageData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import SkillPathwayContext from 'bundles/enterprise-learning-path-description-page/contexts/SkillPathwayContext';
import GetSkillPathwayQuery from 'bundles/enterprise-learning-path-description-page/queries/GetSkillPathwayQuery.graphql';
import type {
  GetSkillPathwayQueryQueryVariables,
  GetSkillPathwayQueryQuery as GetSkillPathwayQueryType,
} from 'bundles/enterprise-learning-path-description-page/queries/__generated__/GetSkillPathwayQuery';

type PropsToComponent = {
  children: React.ReactNode;
};

// Some learning paths are considered "skill pathways" and have additional data pertaining to their associated skills.
// This will return skill area information if the learning path is a skill pathway.
// It will return null if the learning path is not a skill pathway.
const SkillPathwayDataProvider = ({ children }: PropsToComponent) => {
  const learningPathPageData = useEnterpriseLearningPathPageData();
  const badgeTemplateId = learningPathPageData?.enterpriseBadge?.id ?? '';

  const { data, loading, error } = useQuery<GetSkillPathwayQueryType, GetSkillPathwayQueryQueryVariables>(
    GetSkillPathwayQuery,
    {
      skip: !badgeTemplateId,
      variables: { badgeTemplateId },
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
    }
  );

  const skillPathway = data?.VerifiedSkills?.getSkillPathwayByBadgeIdForCurrentUser;

  return (
    <SkillPathwayContext.Provider
      value={{
        skillPathway,
        isSkillPathwayLoading: loading,
        error,
      }}
    >
      {children}
    </SkillPathwayContext.Provider>
  );
};

export default SkillPathwayDataProvider;
